/**
 * MasteringPanelWrapper Component
 * Wrapper for Mastering panel with export handling
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { MasteringPanel } from '../mastering';

export const MasteringPanelWrapper = ({
  isOpen,
  onClose,
  tracks,
  audioContextRef,
  exportWithMastering,
  isMasteringExporting,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed top-0 right-0 bottom-0 z-40">
          <MasteringPanel
            audioBuffer={tracks.find(t => t.type === 'audio' && t.audioBuffer)?.audioBuffer || null}
            audioContext={audioContextRef?.current}
            onExport={(presetId) => {
              exportWithMastering(presetId);
            }}
            isExporting={isMasteringExporting}
            onClose={onClose}
            isVisible={isOpen}
          />
        </div>
      )}
    </AnimatePresence>
  );
};

export default MasteringPanelWrapper;
